import { apiCall } from "./ApiCallBase";
import { API_CONFIG, AUTOMOTIVE_SITE } from "../shared/constants"
import { Vehicle, Dtc} from "../types";

interface GetAnswerResponse {
    messageId: string,
    answer: string,
}

export async function getAnswer(message: string, vehicle: Vehicle, dtcs: Dtc[], sessionId: string, sessionTitle: string){
    const url = `${API_CONFIG.BASE_URL}/chat/get-answer`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    } as Record<string, string>;

    if(AUTOMOTIVE_SITE.IS_AUTO){
        headers['AutomotiveHeader'] = 'automotive-site';
    }

    const requestBody = {
        "ChatQuestion": {
            "userQuestion": message,
            "context": {
                "dtcs": dtcs?.map(i => ({ dtc: i.dtc })),
                "vehicles": [{
                    "make": vehicle.make,
                    "model": vehicle.model,
                    "year": vehicle.year,
                    "engine": "",
                    "mileage": ""
                }]
            }
        },
        "SessionId": sessionId,
        "Agent": "gpt4o",        
        "Title": sessionTitle,
    };

    return await apiCall<GetAnswerResponse>(url, headers, "POST", requestBody);
}

export async function thumbsUp(messageId: string, sessionId: string, IsThumbAdded: boolean){
    const url = `${API_CONFIG.BASE_URL}/chat/thumbsup`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };

    const requestBody = {
        messageId,
        sessionId,
        IsThumbAdded,
    }

    return await apiCall<any>(url, headers, "POST", requestBody);
}

export async function thumbsDown(messageId: string, sessionId: string, IsThumbAdded: boolean){
    const url = `${API_CONFIG.BASE_URL}/chat/thumbsdown`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };

    const requestBody = {
        messageId,
        sessionId,
        IsThumbAdded,
    }

    return await apiCall<any>(url, headers, "POST", requestBody);
}

export async function getSynthesize(text: string) {
    const url = `${API_CONFIG.BASE_URL}/tts/synthesize`
    const headers = {
        "Authorization": `${API_CONFIG.AUTH}`,
        "Content-Type": "application/json",
    };

    return await apiCall<Blob>(url, headers, "POST", { text }, true);
}